exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-search-top input[data-v-dab7d226] {\n  width: 360px;\n}\n.my-release-list__thead th[data-v-dab7d226] {\n  padding: 10px 0 10px 0;\n}\n.flex_end[data-v-dab7d226]{\n  display:flex;\n  justify-content: flex-end;\n  margin-right: 4px;\n  margin-left: 4px;\n}\n.img-header[data-v-dab7d226] {\n  width: 12em;\n}\n.no-data-display[data-v-dab7d226] {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 8rem;\n}\n.no-data-display__title[data-v-dab7d226] {\n  font-weight: bold;\n  font-size: 27px;\n}\n.no-data-display__desc[data-v-dab7d226] {\n  margin: 2rem 0;\n}\n", ""]);

// exports
